// @flow

import {
  PROP_PARENT,
  PROP_ASSET_ID,
  PROP_SHAPE,
  PROP_SEASON,
} from 'fc-model-assets'

import {
  PROP_SUBFIELD,
} from 'fc-model-sampling-jobs'

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'
import _get from 'lodash/get'
import _find from 'lodash/find'
import _isEmpty from 'lodash/isEmpty'

// Selectors
import { fields$, subfields$ } from 'fc-assets'
import { jobs$ } from 'hfty-soil-jobs'
import tableOperation$ from 'hfty-soil-jobs-dom/src/selectors/tableOperation'
import reopenJobOperation$ from 'hfty-soil-jobs-dom/src/selectors/reopenJobOperation'
import selectedSeasonId$ from 'hfty-seasons/src/selectors/selectedSeasonId'

import datatable from 'hfty-soil-jobs-dom/src/datatable'

// Types
import { ReopenJobOperation } from 'hfty-operator-reopen-job/types'

export default createSelector(
  [
    fields$,
    subfields$,
    jobs$,
    datatable.selectors.selectedRecordIds$,
    tableOperation$,
    reopenJobOperation$,
    selectedSeasonId$,
  ],
  function (
    fields: Array<Object>,
    subfields: Array<Object>,
    jobs: Array<Object>,
    selIds: Object,
    op: Object,
    reopenJobOperation: ReopenJobOperation,
    season: number): Object {
    return _filter(fields, (field: Object): Array<Object> => {
      const reopenJobFieldId = _get(reopenJobOperation, 'model.job.field')

      if (reopenJobOperation && reopenJobFieldId === field.id) {
        return true
      }

      if (_isEmpty(field[PROP_SHAPE])) {
        return false
      }

      if (field[PROP_SEASON] !== season) {
        return false
      }

      let subfield = _find(subfields, function (subfield: Object): Object {
        return subfield[PROP_PARENT] === field[PROP_ASSET_ID]
      })

      if (_isEmpty(subfield)) {
        return false
      }

      if (selIds.length > 0 && op && op.operation !== 'ADD') {
        let result = _find(jobs, {id: selIds[0]})

        if (!_isEmpty(result) && !_isEmpty(subfield) && result[PROP_SUBFIELD] === subfield[PROP_ASSET_ID]) {
          return true
        }
      }

      const result = !_find(jobs, function (job: Object): Object {
        return !_isEmpty(subfield) && job[PROP_SUBFIELD] === subfield[PROP_ASSET_ID]
      })

      return result
    })
  }
)
